export default __webpack_public_path__ + "static/media/file_type_doc.23aedb57.svg";